<template>
	<div class="full page_container">

		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="普通转账" v-if="findChildren(116)!==-1" name="transferaccounts" style="height: 100%;">
				<transferaccounts-index />
			</el-tab-pane>		
			<el-tab-pane label="形式转账" v-if="findChildren(149)!==-1" name="formaltransferaccount" style="height: 100%;">
				<formaltransferaccount-index />
			</el-tab-pane>	
		</el-tabs>


	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import transferaccountsIndex from './transferaccounts/index.vue'
	import formaltransferaccountIndex from './formaltransferaccount/index.vue'
	export default {
		props: {

		},
		data() {
			return {
				activeName: '',
				activeIndex: '',
				departmentChildren: []
			}
		},
		watch: {

		},
		created() {
			this.departmentChildren = this.$router.currentRoute.meta.children
			if (this.departmentChildren.length != 0) {
				this.activeName = this.departmentChildren[0].controller
				//this.activeName = 'purchasestockbill'
			}
			//console.log(this.departmentChildren)
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			findChildren(id) {
				return this.departmentChildren.findIndex((item) => {
					return item.id == id
				})
			}
		},
		components: {
			transferaccountsIndex,
			formaltransferaccountIndex	
		}
	}
</script>